import { t } from 'i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { FLOW_LOGO_TEXT } from '@/data';
import { baseStyles, buttonStyles, stepContainerStyles } from '@/styles';
import { PersonalisationFlow, PersonalisationStepId } from '@/types';
import { resetUploadFile } from '../utils';
import './fg-personalisation-file';

const PROCEED_STEP_EVENT_NAME = 'personalisation-proceed-step';

@customElement('fg-personalisation-color-option-step')
export class FgPersonalisationColorOptionStep extends LitElement {
  @property({ type: String })
  fileName?: string;

  @property({ type: Array })
  selectedFlow?: PersonalisationFlow;

  private proceedToNextStep() {
    let step: PersonalisationStepId = PersonalisationStepId.DONE;

    if (this.selectedFlow === FLOW_LOGO_TEXT) {
      step = PersonalisationStepId.TEXT_WITH_FILE;
    }

    this.dispatchEvent(
      new CustomEvent(PROCEED_STEP_EVENT_NAME, {
        detail: step,
      }),
    );
  }

  private proceedToChooseColorsStep() {
    this.dispatchEvent(new Event(PROCEED_STEP_EVENT_NAME));
  }

  render() {
    return html`
      <div class="step-container">
        <fg-personalisation-file
          .fileName=${this.fileName}
          @personalisation-reset-upload=${(event: CustomEvent) =>
            resetUploadFile(this, event)}
        ></fg-personalisation-file>
        <div class="color-selection">
          <button
            class="button button-primary"
            @click=${() => this.proceedToNextStep()}
          >
            ${t('content.personalisation.colorOptionStep.colorsFromFile')}
          </button>
          <button
            class="button button-primary"
            @click=${() => this.proceedToChooseColorsStep()}
          >
            ${t('content.personalisation.colorOptionStep.chooseColors')}
          </button>
        </div>
      </div>
    `;
  }
  static styles = [
    baseStyles,
    buttonStyles,
    stepContainerStyles,
    css`
      fg-personalisation-file {
        margin-bottom: 15px;
      }
      h4 {
        margin: 0 0 5px;
        font-size: 1.125rem;
      }
      .button {
        width: 100%;
      }
      .color-selection {
        display: grid;
        gap: 8px;
        place-items: center;
      }
    `,
  ];
}
